import labelAPI from "../../api/label"
import uuidv4 from "uuid/v4"
import { getItem, setItem } from "../../plugins/localStorage"

const state = {
  options: {
    activeLabelsMenus: {
      newLabel: true,
      labels: true,
    },
    pastelColorsIsActive: true,
    shadowIsActive: true,
  },
  pastelColors: [
    {
      id: "pastel-1",
      name: "blanc",
      bg: "#FFFFFF",
      font: "#707070",
      title: "#393C41",
      contrast: "#FFFFFF",
      border: "#E8E9E9",
    },
    {
      id: "pastel-2",
      name: "jaune clair",
      bg: "#FEFFA7",
      font: "#707070",
      title: "#393C41",
      contrast: "#EAF149",
      border: "#EAF149",
    },
    {
      id: "pastel-3",
      name: "jaune",
      bg: "#FFEBA7",
      font: "#707070",
      title: "#393C41",
      contrast: "#FFD93E",
      border: "#FFD93E",
    },
    {
      id: "pastel-4",
      name: "vert",
      bg: "#D3FFC7",
      font: "#707070",
      title: "#393C41",
      contrast: "#9EDF89",
      border: "#9EDF89",
    },
    {
      id: "pastel-5",
      name: "chair",
      bg: "#FAB5B5",
      font: "#707070",
      title: "#393C41",
      contrast: "#FD8E8E",
      border: "#FD8E8E",
    },
    {
      id: "pastel-6",
      name: "bleu",
      bg: "#DBEBFF",
      font: "#707070",
      title: "#393C41",
      contrast: "#B3D2FF",
      border: "#B3D2FF",
    },
    {
      id: "pastel-7",
      name: "rose",
      bg: "#FFD6F7",
      font: "#707070",
      title: "#393C41",
      contrast: "#FDA3ED",
      border: "#FDA3ED",
    },
    {
      id: "pastel-8",
      name: "violet",
      bg: "#EEBEFF",
      font: "#707070",
      title: "#393C41",
      contrast: "#E490FF",
      border: "#E490FF",
    },
    {
      id: "pastel-9",
      name: "gris",
      bg: "#D3D3D3",
      font: "#707070",
      title: "#393C41",
      contrast: "#AAA7A7",
      border: "#AAA7A7",
    },
    {
      id: "pastel-10",
      name: "vert clair",
      bg: "#EAFFB5",
      font: "#707070",
      title: "#393C41",
      contrast: "#C7E083",
      border: "#C7E083",
    },
  ],
  brightColors: [
    {
      id: "bright-1",
      name: "blanc",
      bg: "#FFFFFF",
      font: "#707070",
      title: "#393C41",
      contrast: "#FFFFFF",
      border: "#E8E9E9",
    },
    {
      id: "bright-2",
      name: "jaune",
      bg: "#D3CB07",
      font: "#FFFFFF",
      title: "#FFFFFF",
      contrast: "#A79D00",
      border: "#A79D00",
    },
    {
      id: "bright-3",
      name: "orange",
      bg: "#FD9500",
      font: "#FFFFFF",
      title: "#FFFFFF",
      contrast: "#D07E00",
      border: "#D07E00",
    },
    {
      id: "bright-4",
      name: "vert",
      bg: "#20BE14",
      font: "#FFFFFF",
      title: "#FFFFFF",
      contrast: "#1B9B00",
      border: "#1B9B00",
    },
    {
      id: "bright-5",
      name: "rouge",
      bg: "#FD4300",
      font: "#FFFFFF",
      title: "#FFFFFF",
      contrast: "#B33000",
      border: "#B33000",
    },
    {
      id: "bright-6",
      name: "bleu",
      bg: "#0045FF",
      font: "#FFFFFF",
      title: "#FFFFFF",
      contrast: "#0700A2",
      border: "#0700A2",
    },
    {
      id: "bright-7",
      name: "rose",
      bg: "#FE00C4",
      font: "#FFFFFF",
      title: "#FFFFFF",
      contrast: "#C9009D",
      border: "#C9009D",
    },
    {
      id: "bright-8",
      name: "violet",
      bg: "#9B007F",
      font: "#FFFFFF",
      title: "#FFFFFF",
      contrast: "#5F0050",
      border: "#5F0050",
    },
    {
      id: "bright-9",
      name: "gris",
      bg: "#393C41",
      font: "#FFFFFF",
      title: "#FFFFFF",
      contrast: "#000000",
      border: "#000000",
    },
    {
      id: "bright-10",
      name: "vert clair",
      bg: "#80B500",
      font: "#FFFFFF",
      title: "#FFFFFF",
      contrast: "#5C8200",
      border: "#5C8200",
    },
  ],
  all: [],
  selected: [],
}

const getters = {
  hasLabels: (state) => {
    return state.all.length > 1
  },

  getGuidsOrdered: (state) => {
    return state.all.map((label) => label.guid_text)
  },

  getName: (state) => (guid) => {
    return state.all.find((label) => label.guid_text === guid).text
  },

  getDefaultName: (state) => {
    return state.all.find((label) => label.is_default === true).text
  },

  getDefaultGuid: (state) => {
    return state.all.find((label) => label.is_default === true).guid_text
  },

  getDefault: (state) => {
    return state.all.find((label) => label.is_default === true)
  },

  getLabelColors: (state, getters) => (guid) => {
    const searchedLabel = state.all.find((label) => label.guid_text === guid)
    return getters.getColors(searchedLabel.color)
  },

  labelExistsWithColor: (state) => (color) => {
    return state.all.find((label) => label.color === color) !== undefined
  },

  getColors: (state) => (colorId) => {
    let pastelColor = state.pastelColors.find((color) => color.id === colorId)

    if (pastelColor) {
      return pastelColor
    }

    let brightColor = state.brightColors.find((color) => color.id === colorId)

    if (brightColor) {
      return brightColor
    }
  },

  getLabel: (state) => (guid) => {
    return state.all.find((label) => label.guid_text === guid)
  },
}

const actions = {
  async uploadToDB({ state }) {
    await labelAPI.newLabels(state.all)
  },

  newLabel({ commit, rootState }, label) {
    label.guid_text = uuidv4().toUpperCase()
    label.question_guid_text = rootState.question.guid_text
    if (state.all.length > 0) {
      label.order = state.all.reduce((max, label) => (label.order > max ? label.order : max), state.all[0].order) + 1
    }

    // case add 2nd label accessible to all, make default accessible
    if (state.all.length === 1 && label.is_for_pilot_only === false) {
      let defaultLabel = Object.assign({}, state.all[0])
      defaultLabel.is_for_pilot_only = false
      this.dispatch("labels/editLabel", { index: 0, label: defaultLabel })
    }

    if (!rootState.app.isOffline) {
      labelAPI.newLabel(label)
      this.dispatch("socket/pushLabel", label)
    } else {
      commit("offline/addApiCallToStack", { api: "label", method: "newLabel", arg: label }, { root: true })
    }

    commit("addLabel", label)
    return label
  },

  editLabel({ commit, state, rootState }, { index, label }) {
    if (!rootState.app.isOffline) {
      labelAPI.editLabel({ guid: state.all[index].guid_text, label: label })
    } else {
      commit(
        "offline/addApiCallToStack",
        { api: "label", method: "editLabel", arg: { guid: state.all[index].guid_text, label: label } },
        { root: true }
      )
    }
    commit("editLabel", { index, label })
    this.dispatch("socket/editLabel", state.all[index])
  },

  deleteLabel({ commit, dispatch, state, rootState, getters }, { index, toLabel }) {
    const deletedLabelGuid = state.all[index].guid_text

    commit("answers/selectAnswersWithLabel", deletedLabelGuid, { root: true })
    dispatch("answers/associateLabelToSelectedAnswers", toLabel !== null ? toLabel : getters["getDefault"], {
      root: true,
    })

    if (!rootState.app.isOffline) {
      this.dispatch("socket/deleteLabel", {
        guid: deletedLabelGuid,
        newGuid: toLabel !== null ? toLabel.guid_text : getters["getDefaultGuid"],
      })

      labelAPI.deleteLabel(deletedLabelGuid)
    } else {
      commit(
        "offline/addApiCallToStack",
        { api: "label", method: "deleteLabel", arg: deletedLabelGuid },
        { root: true }
      )
    }
    commit("deleteLabel", index)

    if (rootState.grid.gridMode === "label" && rootState.answers.orderByLabel[deletedLabelGuid].length === 0) {
      commit("labels/toggleSelected", deletedLabelGuid, { root: true })
    }

    if (state.all.length === 1) {
      const defaultLabel = { ...getters["getDefault"] }
      if (defaultLabel !== undefined) {
        defaultLabel.is_for_pilot_only = true
        dispatch("editLabel", { index: 0, label: defaultLabel })
      }
    }

    let question = getItem("question[" + rootState.question.guid_text + "]")
    question.answers = rootState.answers.all
    question.labels = state.all
    setItem({ name: "question[" + question.guid_text + "]", value: question })
  },

  async setOptionsFromSaved({ commit, dispatch }) {
    let options = getItem("labelsOptions")
    if (options) {
      commit("setOptions", options)
    }
  },

  async setSelectedFromSaved({ commit, dispatch }) {
    let selected = getItem("selectedLabels[" + state.all[0].question_guid_text + "]")
    if (selected) {
      commit("setSelected", selected)
      selected.map((guid) => commit("answers/setOrderByLabel", guid, { root: true }))
    }
  },

  setLabelsOrder({ commit, state, rootState }, htmlLabels) {
    htmlLabels.map((elt, index) => {
      if (parseInt(elt.id) !== index) {
        commit("setLabelOrder", { index: parseInt(elt.id), order: index + 1 })

        if (!rootState.app.isOffline) {
          labelAPI.editLabel({ guid: state.all[index].guid_text, label: state.all[index] })
        } else {
          commit(
            "offline/addApiCallToStack",
            { api: "label", method: "editLabel", arg: { guid: state.all[index].guid_text, label: state.all[index] } },
            { root: true }
          )
        }
      }
    })

    commit("sortLabels")
    commit("grid/setOrderedBy", { orderedBy: null }, { root: true })

    let question = getItem("question[" + state.all[0].question_guid_text + "]")
    question.labels = state.all
    setItem({ name: "question[" + question.guid_text + "]", value: question })
  },
}

const mutations = {
  setQuestionGuid(state, { index, question_guid }) {
    state.all[index].question_guid_text = question_guid
  },

  setGuid(state, { index, guid }) {
    state.all[index].guid_text = guid
  },

  toggleShadowIsActive(state) {
    state.options.shadowIsActive = !state.options.shadowIsActive
    setItem({ name: "labelsOptions[" + state.all[0].question_guid_text + "]", value: state.options })
  },

  setSelected(state, selected) {
    state.selected = selected
  },

  deselectAll(state) {
    state.selected = []
    this.commit("answers/removeAllOrderByLabel")
    setItem({ name: "selectedLabels[" + state.all[0].question_guid_text + "]", value: state.selected }, { root: true })
  },

  toggleSelectAll(state) {
    if (state.selected.length && state.selected.length === state.all.length) {
      state.selected = []
      this.commit("answers/removeAllOrderByLabel")
    } else {
      state.all.map((label) => {
        if (!state.selected.includes(label.guid_text)) {
          state.selected.push(label.guid_text)
          this.commit("answers/setOrderByLabel", label.guid_text)
        }
      })
    }
    setItem({ name: "selectedLabels[" + state.all[0].question_guid_text + "]", value: state.selected }, { root: true })
  },

  toggleSelected(state, guid) {
    if (state.selected.includes(guid)) {
      state.selected.splice(state.selected.indexOf(guid), 1)
      this.commit("answers/removeOrderByLabel", guid)
    } else {
      state.selected.push(guid)
      console.log(state.selected)
      this.commit("answers/setOrderByLabel", guid)
    }
    setItem({ name: "selectedLabels[" + state.all[0].question_guid_text + "]", value: state.selected }, { root: true })
  },

  addLabel(state, label) {
    state.all.push(label)

    let question = getItem("question[" + label.question_guid_text + "]")
    question.labels = state.all
    setItem({ name: "question[" + question.guid_text + "]", value: question })
  },

  editLabel(state, { index, label }) {
    state.all[index].text = label.text
    state.all[index].color = label.color
    state.all[index].initials = label.initials
    state.all[index].is_for_pilot_only = label.is_for_pilot_only
    state.all[index].order = label.order

    let question = getItem("question[" + state.all[index].question_guid_text + "]")
    question.labels = state.all
    console.log(question)
    setItem({ name: "question[" + question.guid_text + "]", value: question })
  },

  deleteLabel(state, index) {
    state.all.splice(index, 1)

    let question = getItem("question[" + state.all[0].question_guid_text + "]")
    question.labels = state.all
    setItem({ name: "question[" + question.guid_text + "]", value: question })
  },

  setLabelOrder(state, { index, order }) {
    state.all[index].order = order
  },

  sortLabels(state) {
    state.all.sort((a, b) => a.order - b.order)
  },

  setLabels(state, labels) {
    state.all = labels
  },

  toggleActiveLabelsMenus(state, menu) {
    state.options.activeLabelsMenus[menu] = !state.options.activeLabelsMenus[menu]
    setItem({ name: "labelsOptions[" + state.all[0].question_guid_text + "]", value: state.options })
  },

  toggleLabelPastelColorsIsActive(state) {
    state.options.pastelColorsIsActive = !state.options.pastelColorsIsActive
    setItem({ name: "labelsOptions[" + state.all[0].question_guid_text + "]", value: state.options })
  },

  setOptions(state, options) {
    if (options) {
      state.options = options
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
